import { PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { PushNotification, fetchNotifications, markAllNotificationsAsRead } from 'src/common/Notification';
import { TActionMeta } from '../../store';
import { NotificationsState } from '../notificationsSlice';

/** Async thunk to fetch notifications from the server. */
export const fetchNotificationsAction = createAsyncThunk('notifications/fetchNotificationsAction', async () => {
  return fetchNotifications();
});

/** Reducer to handle successful notifications fetch and update state. */
export const handleFetchNotifications = (
  state: NotificationsState,
  action: PayloadAction<PushNotification[], string, TActionMeta, never>,
) => {
  state.status = 'idle';
  state.notifications = action.payload;
};

/** Reducer to handle failed notifications fetch and update state. */
export const handleFetchNotificationsFail = (
  state: NotificationsState,
  // action: PayloadAction<unknown, string, TActionMeta, { code?: string; message?: string; name?: string }>
) => {
  state.status = 'failed';
};

/** Async thunk to mark all notifications as read and refetch notifications. */
export const markAllReadAction = createAsyncThunk('notifications/markAllReadAction', async (_, { dispatch }) => {
  await markAllNotificationsAsRead();
  return dispatch(fetchNotificationsAction());
});
